import {emptyArray} from '@packages/utilities/fp/utils';
import type {Type} from '@packages/systems/wfdl';
import type {TranslatedNodeData} from '@packages/systems/localization-types';
import {convertComponentPropertyDefaultToTranslatePayload} from './convertComponentPropertyDefaultToTranslatePayload';

export function getTranslatableComponentPropertiesDefaults(
  componentProperties: {
    [key: string]: Type;
  },
  translatableParentId: string
): TranslatedNodeData[] {
  if (!componentProperties) {
    return emptyArray;
  }

  return Object.keys(componentProperties).flatMap((fieldId) => {
    const type = componentProperties[fieldId];

    if (!type) {
      return emptyArray;
    }

    return convertComponentPropertyDefaultToTranslatePayload(
      fieldId,
      translatableParentId,
      type
    );
  });
}
